module.exports = __webpack_public_path__ + "media/images/web/landings/header_m-b1f05cf0c2ee478d7ad68f346f861026.jpg";